import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardComparisonComponent } from './dashboard-comparison/dashboard-comparison.component';
import { AuthGuard } from './shared/guards/auth.guard';
// Using custom override - bar chart with pink/red color
// import { BarChartComponent } from '@custom';
import { ChatComponent } from '@shared-lib/global-components/chat/chat.component';
import { AccessDeniedComponent } from '@custom';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'pat/first-screen',
    pathMatch: 'full',
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    canActivate: [AuthGuard],
  },

  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'dashboard-config.json' },
  },
   {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'dashboard-config.json' },
  },
   {
    path: 'pat/controller',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/controller.json' },
  },
  {
    path: 'pat/customer_planning',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/customer_planning.json' },
  },
  {
    path: 'pat/image-1',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/image-1.json' },
  },
  {
    path: 'pat/image-2',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/image-2.json' },
  },
  {
    path: 'pat/image-3',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/image-3.json' },
  },
  {
    path: 'pat/customer-planning',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/customer_planning.json' },
  },
  {
    path: 'pat/weightage_score',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/weightage_score.json' },
  },
  {
    path: 'dvm/account-classification',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'dvm/account-classification.json' },
  },
  {
    path: 'dvm/deepdive',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'dvm/deepdive.json' },
  },
  {
    path: 'pat/customer-planning',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/customer_planning.json' },
  },
  {
    path: 'pat/price_planning',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/price_planning.json' },
  },
  {
    path: 'pat/first-screen',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/first-screen.json' },
  },
  {
    path: 'all-charts',
    redirectTo: 'all-chart-1',
    pathMatch: 'full',
  },
  {
    path: 'all-chart-1',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-1.json' },
  },
  {
    path: 'all-chart-2',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-2.json' },
  },
  {
    path: 'pat/second-screen',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/second-screen.json' },
  },
    {
    path: 'pat/image-4',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/image-4.json' },
  },
  {
    path: 'all-chart-3',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-3.json' },
  },
  
  {
    path: 'test',
    component: DashboardComparisonComponent,
    canActivate: [AuthGuard],
  },

   {
    path: 'all-charts-dark-theme',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-charts-theme.json' },
  },
  
  {
    path: 'financial-metrics',
    component: DashboardComponent,
    data: { configFile: 'financial-metrics-poc.json' },
    canActivate: [AuthGuard],
  },
   {
    path: 'detailed_view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu_sales_overview.json' },
  },
   {
    path: 'europe-impact-report',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'europe-Impact-report.json' },
  },
  {
    path: 'dvm-charts_dark-theme',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'detailed_view-dark-theme.json' },
  },

  {
    path: 'dvm-charts',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'detailed_view-light-theme.json' },
  },
  {
    path: 'pat/price-planning-em-level',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/price-planning-em.json' },
  },
  {
    path: 'pat/Engine-model-level',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/Engine-model-level.json' },
  },
  {
    path: 'pat/customer-level-screen',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/customer-level-screen.json' },
  },
  {
    path: 'pat/price-planning-em-level',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'pat/price-planning-em.json' },
  },

  {
    path: 'chat',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: '/chat-config.json' },
  },
  {
    path: '**',
    redirectTo: 'pat/first-screen.json',
  },
];
